export default __webpack_public_path__ + "static/media/ColHeader.0c85463b.png";